module.exports = __webpack_public_path__ + "static/media/refer_a_friend_preview.6d59f9e4.png";